/* EaseDaily homepage/global chrome behavior: theme toggle, mobile nav, review pause-on-click */
(function () {
  'use strict';

  var STORAGE_KEY = 'ed-theme';

  function getStoredTheme() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function storeTheme(v) {
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
  }
  function systemPrefersDark() {
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  function applyTheme(theme) {
    document.documentElement.setAttribute('data-ed-theme', theme);
    document.querySelectorAll('[data-ed-theme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
    });
  }
  function initTheme() {
    var stored = getStoredTheme();
    /* Light is the default for first-time visitors, regardless of their
       system/OS preference. A visitor who explicitly toggles the theme
       gets that explicit choice remembered and respected from then on. */
    var theme = stored || 'light';
    applyTheme(theme);
  }
  function toggleTheme() {
    var current = document.documentElement.getAttribute('data-ed-theme') === 'dark' ? 'dark' : 'light';
    var next = current === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    storeTheme(next);
  }

  function setMenuToggleState(btn, isOpen) {
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    btn.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
    var menuIcon = btn.querySelector('[data-ed-icon-menu]');
    var closeIcon = btn.querySelector('[data-ed-icon-close]');
    if (menuIcon && closeIcon) {
      menuIcon.style.display = isOpen ? 'none' : 'block';
      closeIcon.style.display = isOpen ? 'block' : 'none';
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-ed-theme-toggle]');
    if (toggle) { toggleTheme(); return; }

    var menuBtn = e.target.closest('[data-ed-menu-toggle]');
    if (menuBtn) {
      var nav = document.querySelector('[data-ed-mobile-nav]');
      if (nav) {
        var willOpen = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', willOpen);
        setMenuToggleState(menuBtn, willOpen);
      }
      return;
    }

    var reviewsWrap = e.target.closest('[data-ed-reviews]');
    if (reviewsWrap) {
      reviewsWrap.classList.toggle('is-paused');
    }

    var cookieAccept = e.target.closest('[data-ed-cookie-accept]');
    if (cookieAccept) { setCookieConsent('accepted'); return; }

    var cookieDecline = e.target.closest('[data-ed-cookie-decline]');
    if (cookieDecline) { setCookieConsent('declined'); return; }
  });

  /* ---- Cookie consent banner ---- */
  var COOKIE_KEY = 'ed-cookie-consent';

  function getCookieConsent() {
    try { return localStorage.getItem(COOKIE_KEY); } catch (e) { return 'accepted'; }
  }
  function setCookieConsent(value) {
    try { localStorage.setItem(COOKIE_KEY, value); } catch (e) {}
    var banner = document.getElementById('ed-cookie-banner');
    if (banner) {
      banner.classList.remove('is-visible');
      banner.hidden = true;
    }
    document.body.classList.remove('ed-cookie-active');
  }
  function initCookieBanner() {
    var banner = document.getElementById('ed-cookie-banner');
    if (!banner || getCookieConsent()) return;
    banner.hidden = false;
    document.body.classList.add('ed-cookie-active');
    window.requestAnimationFrame(function () {
      banner.classList.add('is-visible');
    });
  }

  /* ---- Cart progress bar (auto 10% off over ₹1500) ----
     The discount itself is a native Shopify automatic discount (applies at
     cart/checkout regardless of theme); this bar is just the visual nudge
     toward it. Polls /cart.js so it stays correct even when the shopper
     changes quantities inside Shopify's own cart drawer/cart page, which
     don't go through our ajax add-to-cart flow. */
  var CART_GOAL_CENTS = 150000; /* ₹1500, in paise */

  function updateCartProgress(cart, bar) {
    var fill = bar.querySelector('[data-ed-cart-progress-fill]');
    var text = bar.querySelector('[data-ed-cart-progress-text]');

    if (!cart || cart.item_count === 0) {
      bar.hidden = true;
      return;
    }

    var total = cart.total_price;
    var pct = Math.min((total / CART_GOAL_CENTS) * 100, 100);
    if (fill) fill.style.width = pct + '%';

    if (total >= CART_GOAL_CENTS) {
      bar.classList.add('is-complete');
      if (text) text.textContent = "You've unlocked 10% off your order!";
    } else {
      bar.classList.remove('is-complete');
      var remaining = Math.ceil((CART_GOAL_CENTS - total) / 100);
      if (text) text.textContent = 'Add ₹' + remaining + ' more to unlock 10% off';
    }

    bar.hidden = false;
  }

  /* Only present in the DOM on the cart page (see layout/theme.liquid) — on
     every other page this whole block is skipped, so there's no polling or
     listener overhead where the bar can never appear. */
  function initCartProgress() {
    var bar = document.querySelector('[data-ed-cart-progress]');
    if (!bar) return;

    function fetchCartProgress() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (cart) { if (cart) updateCartProgress(cart, bar); })
        .catch(function () {});
    }

    document.addEventListener('cart:refresh', fetchCartProgress);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') fetchCartProgress();
    });
    window.setInterval(fetchCartProgress, 6000);
    fetchCartProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTheme();
      initCookieBanner();
      initCartProgress();
    });
  } else {
    initTheme();
    initCookieBanner();
    initCartProgress();
  }
})();
